import React from "react";
import Services from "../components/Services";
import PageHero from "../components/PageHero";
import ModernCTA from "../components/ModernCTA";

function ServicesPage() {
  return (
    <>
      <PageHero
        title="Our Services"
        crumb="Services"
        subtitle="Comprehensive civil construction solutions delivered with precision and excellence"
      />
      <Services />
      <ModernCTA />
    </>
  );
}

export default ServicesPage;
